import React, { Component } from 'react';
import { Modal, Button } from 'react-bootstrap';

/**
* Class ModalMessage
* Generic component to generate modal messages
**/
class ModalMessage extends Component {
  /**
  * props
  * parent : parent component
  * style : modal style, one of: "success", "warning", "danger", "info"
  * title : modal title
  * message : modal message
  * onlyOk : true to display only the "OK" button
  * handleOk : handleOk callback
  * handleCancel : handleCancel callback
  * visible : true to show this component
  **/

  /**
  * constructor
  * Constructor
  **/
  constructor(props) {
    super(props);

    this.state = props;

    this.props.parent.modalMessage = this;
    this.handleOk = this.handleOk.bind(this);
    this.handleCancel = this.handleCancel.bind(this);
  }

  /**
  * render
  * Rendering component function : display the status bar
  **/
  render() {
    this.state = this.props;

    if(this.state.visible === true) {
      const cancelButton = <Button onClick={this.handleCancel}>Annuler</Button>;
      const style = (this.state.style !== undefined ? this.state.style : "info");

      return (
        <Modal show={this.state.visible} onHide={this.handleCancel} dialogClassName={"modal-alert " + style}>
          <Modal.Header closeButton>
            <Modal.Title>
              <i className="glyphicon glyphicon-warning-sign"/><span>{this.state.title}</span>
            </Modal.Title>
          </Modal.Header>
          <Modal.Body>
            {this.state.message}
            <p style={{textAlign: "right"}}><Button onClick={this.handleOk} bsStyle={style}>OK</Button>
            {this.state.onlyOk === true ? "" : cancelButton}</p>
          </Modal.Body>
        </Modal>
      );
    }

    return null;
  }

  /**
  * handleOk
  * Handle OK click
  **/
  handleOk() {
    this.setState({visible: false});

    if(typeof this.state.handleOk === "function") {
      this.state.handleOk.call(this.state.parent, true);
    }
  }

  /**
  * handleCancel
  * Handle cancel click
  **/
  handleCancel() {
    this.setState({visible: false});

    if(typeof this.state.handleCancel === "function") {
      this.state.handleCancel.call(this.state.parent, false);
    }
  }

}

export default ModalMessage;



// WEBPACK FOOTER //
// ./src/views/Helper/ModalMessage.js